/**
 * SVG icon for security aspect
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function SymbolSecurityBig({ hoveredAspect }) {
  return (
    <symbol
      className="wheel-icon"
      id="icon-security"
      viewBox="0 0 103.5 119.5"
    >
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:61',
            st0: true,
          })}
          d="M58.8,3.1c-6.7,1.1-41.3,7.3-49,33.6S14,80.6,17,83.9c3,3.3,15.6,17.9,20.3,10.8c0.6-1.9,0-4-1.6-5.2 c-13.1-9.4-22.5-24-14.8-49.6C27.5,17.9,52,11,62.1,9.1c1.7-0.3,2.9-1.5,3.4-3.1C65.6,5.6,65.1,2.1,58.8,3.1z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:61',
            st1: true,
          })}
          d="M65.8,3.7c-0.4-2.4-2.6-4-5-3.7C47.9,1.5,9.9,8.3,2.4,37.3c-10.9,42.1,18.1,57.1,28.4,61c2,0.8,4.2,0,5.4-1.7 l0.5-0.8c0.2-0.3,0.4-0.7,0.5-1.1c-4.6,7.1-17.3-7.5-20.3-10.8c-3-3.3-14.8-20.8-7.1-47.1s42.2-32.5,49-33.6c6.3-1,6.7,2.4,6.8,2.9 C65.8,5.3,65.9,4.5,65.8,3.7z"
        />
      </g>
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:61',
            st0: true,
          })}
          d="M71.1,22.5c-0.3-0.2-0.6-0.2-1-0.3c-0.2,0.1-4.7,1.2-1.8,4.8c3,3.7,26.3,16,24.4,34.4s-13.6,34.1-22.9,40.8 c-5.6,4.1-23.7,8.4-29.5,9.9c-5.7,1.4-2.1,7-2,7.3c0.4,0.1,0.8,0.2,1.2,0.2c12.3,0,47.3-3.1,60.6-37.9 C113.8,46.2,82,27.7,71.1,22.5z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:61',
            st1: true,
          })}
          d="M40.3,112.1c5.8-1.4,23.9-5.8,29.5-9.9c9.3-6.7,21-22.4,22.9-40.8S71.4,30.7,68.4,27c-2.9-3.6,1.5-4.7,1.8-4.8 c-1.7-0.4-3.5,0.3-4.5,1.8c-1.3,2-0.8,4.8,1.3,6.1c8.2,5.2,25.9,19.8,15.5,45.6c-10.6,26.3-34.4,32.5-43.5,33.9 c-2.1,0.3-3.7,2.1-3.7,4.3v1.3c0,2,1.3,3.6,3.1,4.2C38.2,119.1,34.7,113.5,40.3,112.1z"
        />
      </g>
    </symbol>
  );
}

SymbolSecurityBig.propTypes = {
  hoveredAspect: PropTypes.string,
};

export default SymbolSecurityBig;



// WEBPACK FOOTER //
// js/src/wheel/symbols/SymbolSecurityBig.js